import React from "react";
import WhatsappIconImg from "../../../src/assets/images/whatsapp.svg"; 


// ../../assets/images/WhatsappIcon.svg

export const WhatsappIcon = () => {
    return (
        <div  style={{position:"fixed",top:"60%",right:0}} >
            <a href="https://wa.me/+919445979137">
            <img style={{width:50,height:50}} src={WhatsappIconImg} alt="WhatsApp Icon" />
            </a>
        </div>
    );
};
